module.exports = __webpack_public_path__ + "img/HQ-Z7030-V2.d86ff831.jpg";